import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Spin, Table, Typography } from 'antd'
import { ArrowLeftOutlined, LoadingOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { apiCalls } from '../../../shared/Apis';

const { Text } = Typography
const SingleViewNotification = () => {
    let { notiId } = useParams()
    const navigate = useNavigate() 
    const [ loading, setLoading ] = useState(false)
    const [ singleData, setSingleData ] = useState(null)

    const SingleViewNotify = async() => {
        setLoading(true)
        const result = await apiCalls?.Notificationpostapi?.SingleViewNotify(notiId)
        if(result)
            setSingleData(result)
            setLoading(false)
    }

    useEffect(()=>{
        SingleViewNotify()
    },[notiId])


    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                      title: <Text className='cursor text-gray' onClick={()=>navigate('/notification')}>Notifcation</Text>,
                    },
                    {
                      title: <Text className='fw-500'>
                        {singleData?.title}
                      </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    {
                        loading ?
                        <Col span={24}>
                            <Flex justify="center" align="center" className="h-100 w-100 mt-3">
                                <Spin indicator={<LoadingOutlined className="text-brand" spin />} size="large" />
                            </Flex>
                        </Col>
                        :
                        <>
                            <Col span={24}>
                                <Space>
                                    <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/notification')}>
                                        <ArrowLeftOutlined />
                                    </Button>
                                    <Text className='fw-500'>
                                        {singleData?.title}
                                    </Text>
                                </Space>
                            </Col>  
                            <Col span={24}>
                                <Text>
                                    {
                                        singleData?.description
                                    }
                                </Text>
                            </Col>
                        </>
                    }
                </Row>
            </Card>
        </div>
    )
}

export { SingleViewNotification }
